export const LEAD_VALIDATION = {
  SOURCE_REQUIRED: "请选择来源",
  LEAD_AT_REQUIRED: "请选择客资日期时间",
  RETENTION_TYPE_REQUIRED: "请选择留资形式",
  NOTE_MAX_LENGTH: 500,
} as const

export const LEAD_DICT_CODES = {
  SOURCE: "LEAD_SOURCE",
  RETENTION_TYPE: "LEAD_RETENTION_TYPE",
} as const
